/**
 * Demo mode shows sample GCC designs only. New designs cannot be created while
 * it is on (WI 2368): the UI shows this as the tooltip on the disabled
 * New GCC Design buttons, and POST /api/ai/gcc returns it with a 403.
 */
export const GCC_DEMO_MODE_BLOCKED_MESSAGE =
  'Turn off Demo Mode in Settings to create a new GCC design.'
